import baseTheme from "../../themes/base-theme";

const theme = {
    ...baseTheme,
};

export default theme;
